module.exports = __webpack_public_path__ + "static/media/practice.9bc6e345.svg";